import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let accessToken = null;
let refreshing = null;
let onLogout = () => {};

export const setAccessToken = (t) => { accessToken = t; };
export const getAccessToken = () => accessToken;
export const setLogoutHandler = (fn) => { onLogout = fn; };

export const refreshSession = () => {
  if (!refreshing) {
    refreshing = api.post("/auth/refresh", null, { _noRetry: true })
      .then((r) => { accessToken = r.data.access_token; return r.data; })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
};

api.interceptors.request.use((cfg) => {
  if (accessToken && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${accessToken}`;
  return cfg;
});

api.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config || {};
  const isAdmin = cfg.url?.startsWith("/admin") || cfg.url?.startsWith("/auth/me") || cfg.url?.startsWith("/auth/sessions");
  if (err.response?.status === 401 && isAdmin && !cfg._noRetry && !cfg._retried) {
    try {
      await refreshSession();
      cfg._retried = true;
      cfg.headers.Authorization = `Bearer ${accessToken}`;
      return api(cfg);
    } catch {
      accessToken = null;
      onLogout();
    }
  }
  return Promise.reject(err);
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Bir hata oluştu. Lütfen tekrar deneyin.";
};

export const img = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");
